import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Pagination } from "react-bootstrap";

function ViewEmployeeReportsByDoctor({user}) {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();

  const token = JSON.parse(localStorage.getItem("data")).token;
  
  useEffect(() => {
       if (searchTerm.trim()) {
         searchData(0);  
       } else {
         getData(currentPage);   
     }
     }, [searchTerm]); 
   
    
    const searchData = async (pageNumber = 0) => {
        setLoader(true);
        try {
         const searchUrl = `/api/employeeappointment/searchReportsByReportId`;
                  const requestData = {
                    searchTerm,
                    reportstatus:'APPROVED'
                  };
            
          const response = await axios.post(searchUrl, requestData, {
            params: {userid:user, page: pageNumber },
            headers: { Authorization: `Bearer ${token}` },
          });
          setAppointmentDetails(response.data.content);
          setCurrentPage(response.data.number);
          setTotalPages(response.data.totalPages);
         setLoader(false);
   
       } catch (error) {
        setLoader(false);
         handleError(error);
       }
     };
  
     const getData = async (pageNumber = 0) => {
      setLoader(true);
      try {
    
        const trans = await axios.get(`/api/employeeappointment/getapproved-reports/userid=${user}`, {
          params: { page: pageNumber }, 
          headers: { Authorization: `Bearer ${token}` },
        });
    
        console.log(trans);
    
        setAppointmentDetails(trans.data.content);
        setCurrentPage(trans.data.number);
        setTotalPages(trans.data.totalPages);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };
    
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    
      if (searchTerm.trim()) {
        searchData(newPage);
      } else {
        getData(newPage);
      }
    };

const [pdfUrl, setPdfUrl] = useState(null);
const handleViewPdf = async (appointmentId) => {
  const token = JSON.parse(localStorage.getItem("data")).token;
  await axios({
    url: `/api/employeeappointment/download/id=${appointmentId}`,
    method: "GET",
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    console.log("filedata;", response);
    const contentType = response.headers["content-type"];
    let extension = "";

    // Determine the file extension based on content type
    if (contentType.includes("application/pdf")) {
      extension = "pdf";
    } else if (contentType.includes("image/jpeg")) {
      extension = "jpg";
    } else if (contentType.includes("image/png")) {
      extension = "png";
    } else {
      console.error("Unsupported file type:", contentType);
      return;
    }

    // Create a blob URL and download link for the file
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `file.${extension}`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
}
const handleBack = async () => {
  navigate(-1);
};
const renderPageNumbers = () => {
  const pageNumbers = [];
  const maxPageNumbersToShow = 5;
  let startPage = Math.max(0, currentPage - 2);
  let endPage = Math.min(totalPages - 1, currentPage + 2);

  if (currentPage <= 2) {
    endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
  }

  if (currentPage >= totalPages - 3) {
    startPage = Math.max(0, totalPages - maxPageNumbersToShow);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
        {i + 1}
      </Pagination.Item>
    );
  }
  return pageNumbers;
};

function handleError(error) {
  if (error.response) {
    if (error.response.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else if (error.response.data && error.response.data.message) {
      toast.error(error.response.data.message);
    }  else if (error.response.data && error.response.data.code) {
      toast.error(error.response.data.code);
    }
     else {
      toast.error("An error occurred.");
    }
  } else if (error.message) {
    toast.error(error.message);
  } else {
    toast.error("An error occurred.");
  }
}

const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
const [selectedPackage, setSelectedPackage] = useState(null);
const openTestsModal = (pkg) => {
  setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
};

const closeTestsModal = () => {
  setSelectedPackage(null);
  setIsTestsModalOpen(false);
};
  return (
    <div>
      <div className="col-12 mx-xl-auto">
        <div className="mb-2">
      <button className="btn btn-primary" onClick={handleBack}>
      Back
    </button>
    </div>
        <div className="card card-raised">
          <div className="card-body">
          <div className="form-group position-relative" style={{ width: '300px' }}>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by Report Id"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ paddingLeft: "2rem", width: "100%" }}
                />
                <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </div>
              <br/>
            <div className="d-flex">
             
            <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                  <th>Employee Name</th>
                  <th>Date</th>
                  <th>Lab Name</th>
                  <th>Package Name</th>
                  <th>Report Id</th>
                  <th>Report</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment) => (
                    <tr key={appointment.id}>
                        <td>{appointment.emplo?.name} {appointment.emplo?.lastname}</td>
                      <td>{appointment.date}</td>
                      <td>{appointment.labs.labname}</td>
                      <td>
                                 {appointment.pack!==null && (
                                                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                                                                                <span style={{
                                                                                  backgroundColor: '#405469ff',
                                                                                  color: 'white',
                                                                                  padding: '6px 12px',
                                                                                  borderRadius: '20px',
                                                                                  fontWeight: '500',
                                                                                  display: 'inline-block',
                                                                                  fontSize: '14px'
                                                                                }}>{appointment.pack?.packagename}</span>
                                                                                <FiInfo
                                                                                   onClick={() => openTestsModal(appointment.packageid)}
                                                                                  style={{
                                                                                    cursor: 'pointer',
                                                                                    fontSize: '24px',
                                                                                  }}
                                                                                />
                                                                               </div>
                                 )}
                                                                  
                                                         <div>
                                                            {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                                                              <>
                                                          Additional Tests:
                                                           <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                                    {
                                                      appointment.additionalTest.map((test, i) => (
                                                        <li key={i}>{test.testDetails?.testname}</li>
                                                      ))
                                                
                                                    }
                                                  </ul>
                                                  </>
                                                            )}
                                                         </div>
                                                                  </td>
                      <td>{appointment.reportId}</td>
                      <td>
  {appointment.reportstatus ? (
    appointment.reportstatus === 'APPROVED' ? (
      <button
        className="btn btn-primary"
        onClick={() => handleViewPdf(appointment.id)}
      >
        View
      </button>
    ) : (
      "Approval Pending"
    )
  ) : (
    "No Report Added"
  )}
</td>
                                 
                    </tr>
                  ))
                )}
              </tbody>
            </table>
           
          </div>
          <div className="d-flex justify-content-center">
                <Pagination>
                  <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                  <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                  {renderPageNumbers()}
                  <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                  <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
                </Pagination>
              </div>
        </div>
        {isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}
        {loader && <div className="loading"></div>}
      </div>
    </div>
    </div>
  );
}

export default ViewEmployeeReportsByDoctor;
